// src/finance/components/RevenueTimeline.tsx
// Bande du haut du Calculateur : le CA du scénario mix décliné par granularité.
// Présentation seule — les conversions viennent de src/finance/timeline.ts.
import type { RevenueTimelineValues } from '../timeline'
import { fmtEur } from '../format'

const STEPS = [
  ['hourly', 'À l’heure'],
  ['daily', 'À la journée'],
  ['weekly', 'À la semaine'],
  ['monthly', 'Au mois'],
] as const

export function RevenueTimeline({
  values,
  billableDays,
  hoursPerDay,
}: {
  values: RevenueTimelineValues
  billableDays: number
  hoursPerDay: number
}) {
  return (
    <section
      data-testid="revenue-timeline"
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--line)',
        borderRadius: '10px',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.625rem',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          gap: '0.5rem',
        }}
      >
        {STEPS.map(([key, label]) => {
          const amount = values[key]
          const isPivot = key === 'monthly'
          return (
            <div
              key={key}
              style={{
                background: isPivot ? 'var(--elevated)' : 'transparent',
                border: `1px solid ${isPivot ? 'var(--line-strong)' : 'var(--line)'}`,
                borderRadius: '8px',
                padding: '0.625rem 0.75rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem',
              }}
            >
              <span
                style={{
                  fontSize: '0.6875rem',
                  color: 'var(--muted)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                }}
              >
                {label}
              </span>
              <span
                style={{
                  fontSize: isPivot ? '1.125rem' : '0.9375rem',
                  fontWeight: 600,
                  color: 'var(--fg)',
                  fontFamily: 'var(--mono)',
                }}
              >
                {amount === null ? '—' : fmtEur(amount)}
              </span>
            </div>
          )
        })}
      </div>
      <span style={{ fontSize: '0.6875rem', color: 'var(--dim)' }}>
        Base : {billableDays} j facturables/mois · {hoursPerDay} h/j · scénario mix
      </span>
    </section>
  )
}
